if($('#js-logoSlider').length){
	let logoSlider = new Swiper('#js-logoSlider', {
		loop: true,
		slidesPerView: 2.8,
		spaceBetween: 16,
		speed: 2000,
		allowTouchMove: false,
		autoplay: {
			delay: 0
		},
		breakpoints: {
			1024: {
				slidesPerView: 7.7,
				spaceBetween: 20,
			},
		},
	});
}

if($('#js-reasonTitleSlider').length){
	let reasonTitleSlider = new Swiper('#js-reasonTitleSlider', {
		loop: false,
		speed: 500,
		slidesPerView: 'auto',
		spaceBetween: 5,
		freeMode: true,
		watchSlidesProgress: true,
		breakpoints: {
			1024: {
				slidesPerView: 4,
				spaceBetween: 12,
			},
		},
	});
	let reasonContentsSlider = new Swiper('#js-reasonContentSlider', {
		loop: true,
		speed: 500,
		centeredSlides: true,
		spaceBetween: 20,
		slidesPerView: 'auto',
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		thumbs: {
			swiper: reasonTitleSlider,
		},
		breakpoints: {
			1024: {
			},
			1366: {
				spaceBetween: 120,
			},
		},
	});
}

if($('#js-startSlider').length){
	let autoplay = true;
	let startSlider = new Swiper('#js-startSlider', {
		loop: true,
		speed: 1000,
		effect: 'creative',
		creativeEffect: {
			prev: {
				opacity: 0,
			},
			next: {
				opacity: 0,
			},
		},
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});
	$('.swiper-button-pause').on('click', function(){
		$(this).toggleClass('is-pause');
		if(autoplay){
			startSlider.autoplay.stop();
			autoplay = false;
		} else {
			startSlider.autoplay.start();
			autoplay = true;
		}
	});
}
